import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';

import type { ThemeBottomProps } from '../../../theme/system-utilities';
import { themeBottom } from '../../../theme/system-utilities';
import Border from './index';

const UnstyledBorderBottom = styled(Border)<ThemeBottomProps>`
  ${themeBottom};
`;

const BorderBottom = (props: ComponentProps<typeof UnstyledBorderBottom>) => (
  <UnstyledBorderBottom themeBottom="sp_0" {...props} />
);

export default BorderBottom;
